import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS_Mapper extends BaseFormMapper<HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS> {
		return {};
	}
}

const Mappings: HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS = {
	// "0":"Button5",
	year: 'Text4',
	dayMonth: 'Text3',
	city: 'Text2',
	payableTo: 'Text1',
	payableToName: 'or as hethey may in writing direct and this shall be your',
	address: 'Address',
	mortgageLoanTo: 'Mortgage Loan To',
	homeTrustCompanyMortgageNumber: 'Home Trust Company Mortgage No',
	andTo: 'AND TO',
	line4: '4',
	line3: '3',
	line2: '2',
	line1: '1',
};

export interface HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS {
	andTo: string;
	homeTrustCompanyMortgageNumber: string;
	mortgageLoanTo: string;
	address: string;
	payableTo: string;
	payableToName: string;
	line1: string;
	line2: string;
	line3: string;
	line4: string;

	city: string;
	dayMonth: string;
	year: string;
}
